export default __webpack_public_path__ + "static/media/loader_arbitrum.9745a862.gif";